interface PayPalCTAProps {
  text: string;
}

export default function PayPalCTA({ text }: PayPalCTAProps) {
  return (
    <div className="w-screen flex justify-center">
      <div className="w-full max-w-[1280px] px-8">
        <div className="w-full bg-white rounded-lg flex items-center justify-between p-[1.25em]">
          <span className="body-medium">{text}</span>
          <a 
            href="https://www.paypal.com/donate/?hosted_button_id=3WF6J6GA3WAVG"
            target="_blank"
            rel="noopener noreferrer"
            className="w-fit flex items-center gap-3 px-10 py-2.5 text-white bg-[#003CFF] rounded-[200px] transition-all duration-300 hover:bg-black hover:px-12 hover:text-white"
          >
            <span className="body-small">Donar</span>
            <span>→</span>
          </a>
        </div>
      </div>
    </div>
  )
} 